
import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-card mt-auto border-t border-border">
      <div className="container mx-auto px-4 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-1">
            <Link to="/" className="flex items-center gap-2">
              <div className="w-10 h-10 relative">
                <img 
                  src="/lovable-uploads/dff65184-ca91-4050-9adb-6a89af6fba3e.png" 
                  alt="IA PALPITE GURU Mascote" 
                  className="w-full h-full object-contain"
                />
              </div>
              <span className="font-bold text-xl">PALPITE GURU</span>
            </Link>
            <p className="mt-4 text-sm text-muted-foreground">
              A plataforma mais avançada para previsões no jogo do bicho utilizando inteligência artificial.
            </p>
          </div>
          
          <div>
            <h3 className="font-medium text-lg mb-3">Plataforma</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Início</Link></li>
              <li><Link to="/gerar-jogos" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Gerar Jogos com IA</Link></li>
              <li><Link to="/software" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Software Turbinado</Link></li>
              <li><Link to="/demo" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Experimentar Demo</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="font-medium text-lg mb-3">Planos</h3>
            <ul className="space-y-2">
              <li><Link to="/planos" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Plano Básico</Link></li>
              <li><Link to="/planos" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Plano Premium</Link></li>
              <li><Link to="/planos" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Plano VIP</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="font-medium text-lg mb-3">Suporte</h3>
            <ul className="space-y-2">
              <li><Link to="/contato" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Contato</Link></li>
              <li><Link to="/confirmar-email" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Não recebeu o e-mail de confirmação?</Link></li>
              <li><Link to="/duvidas" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Dúvidas Frequentes</Link></li>
              <li><Link to="/termos" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Termos de Uso</Link></li>
              <li><Link to="/sobre-nos" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Sobre Nós</Link></li>
              <li><Link to="/uso-responsavel" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Uso Responsável</Link></li>
            </ul>
          </div>
        </div>

        {/* Aviso jurídico discreto */}
        <div className="mt-10 pt-6 border-t border-border">
          <p className="text-xs text-center text-muted-foreground/80 leading-relaxed max-w-3xl mx-auto">
            📊 Plataforma baseada em análises estatísticas, tendências históricas e inteligência artificial aplicada para fins de entretenimento.
          </p>
        </div>

        <div className="mt-6 pt-6 border-t border-border flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-muted-foreground">
            &copy; {new Date().getFullYear()} PALPITE GURU. Todos os direitos reservados.
          </p>
          <div className="mt-4 md:mt-0 flex gap-4">
            <Link to="/privacidade" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Política de Privacidade</Link>
            <Link to="/termos" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Termos de Uso</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
